export default __webpack_public_path__ + "static/businessEnglishCard-35c1dcbe63a557bf164065e34306ed8a.png";